var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b;
import { css, html, LitElement } from "lit";
import { customElement, property, query } from "lit/decorators.js";
import { SpectrumZoomEvent } from "./events.js";
import { DragController } from "../controls/drag-controller.js";
import * as Icons from "../icons.js";
import { Zoom, DefaultZoom } from "../coordinates/zoom.js";
import { BaseStyle } from "../styles.js";
let RrScrollbar = class RrScrollbar extends LitElement {
    constructor() {
        super(...arguments);
        this.zoom = DefaultZoom;
    }
    static get styles() {
        return [
            BaseStyle,
            css `
        :host {
          display: flex;
          flex-direction: row;
          width: 100%;
        }

        #scroll {
          flex: 1;
          display: flex;
          flex-direction: row;
          border: solid ButtonBorder;
          border-width: 1px 0 1px 0;
        }

        #thumb {
          flex: 1;
        }

        #left,
        #right {
          background: color-mix(in srgb, ButtonFace, lightgray 35%);
        }

        #thumb {
          background: lightgray;
          border: 1px outset;
        }
      `,
        ];
    }
    render() {
        return html `<button @click=${this.onClickButtonLeft}>
        ${Icons.ScrollLeft}
      </button>
      <div id="scroll">
        <div
          id="left"
          style="width: ${this.zoom ? 100 * this.zoom.leftFraction : 0}%"
          @click=${this.onClickAreaLeft}
        ></div>
        <div id="thumb" @pointerdown=${this.onPointerDown}></div>
        <div
          id="right"
          style="width: ${this.zoom ? 100 * (1 - this.zoom.rightFraction) : 0}%"
          @click=${this.onClickAreaRight}
        ></div>
      </div>
      <button @click=${this.onClickButtonRight}>${Icons.ScrollRight}</button>`;
    }
    firstUpdated(changed) {
        super.firstUpdated(changed);
        this.dragController = new DragController(new ScrollbarDragHandler(this, this.scrollBox), 0);
    }
    onClickButtonLeft() {
        this.moveZoom(-1 / 20);
    }
    onClickButtonRight() {
        this.moveZoom(1 / 20);
    }
    onClickAreaLeft() {
        this.moveZoom(-0.6);
    }
    onClickAreaRight() {
        this.moveZoom(0.6);
    }
    moveZoom(fractionOfSpan) {
        let zoom = this.zoom.withMovedCenter(fractionOfSpan / this.zoom.level);
        this.zoom = zoom;
        this.dispatchEvent(new SpectrumZoomEvent(zoom));
    }
    onPointerDown(e) {
        this.dragController?.startDragging(e);
    }
};
__decorate([
    property({ attribute: false }),
    __metadata("design:type", typeof (_a = typeof Zoom !== "undefined" && Zoom) === "function" ? _a : Object)
], RrScrollbar.prototype, "zoom", void 0);
__decorate([
    query("#scroll"),
    __metadata("design:type", typeof (_b = typeof HTMLElement !== "undefined" && HTMLElement) === "function" ? _b : Object)
], RrScrollbar.prototype, "scrollBox", void 0);
RrScrollbar = __decorate([
    customElement("rr-scrollbar")
], RrScrollbar);
export { RrScrollbar };
class ScrollbarDragHandler {
    constructor(scrollbar, box) {
        this.scrollbar = scrollbar;
        this.box = box;
        this.startZoom = DefaultZoom;
    }
    startDrag() {
        this.startZoom = this.scrollbar.zoom;
    }
    drag(deltaX, _) {
        let fraction = deltaX / this.box.offsetWidth;
        this.moveZoom(fraction);
    }
    finishDrag() { }
    cancelDrag() {
        this.moveZoom(0);
    }
    onClick() { }
    moveZoom(fraction) {
        let newZoom = this.startZoom.withMovedCenter(fraction);
        this.scrollbar.zoom = newZoom;
        this.scrollbar.dispatchEvent(new SpectrumZoomEvent(this.scrollbar.zoom));
    }
}
